<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full">
    <div class="w-full rounded-large bg-dark spacing-md md:spacing-lg flex flex-col gap">
        <div class="split-header-container">
            <h2 class="text-white">
                Deine Probleme<br />
                möchten wir haben!
            </h2>

            <p class="text-white md:text-xl">
                Wir kennen die Herausforderungen der digitalen Welt und haben für jede dieser
                Herausforderungen eine Lösung parat.
            </p>
        </div>

        <div class="grid lg:grid-cols-2 gap">
            <div class="card muted flex flex-col gap-6 my-auto text-dark">
                <h3 class="font-medium">Deine Probleme</h3>

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-red-500 hidden"
                    width="32"
                    height="32"
                    fill="currentColor"
                    viewBox="0 0 256 256">
                    <defs>
                        <path
                            id="x-icon"
                            d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
                    </defs>
                </svg>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 text-red-500 shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#x-icon"></use>
                    </svg>
                    <span>Kaum Neukunden trotz hoher Werbekosten?</span>
                </div>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 text-red-500 shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#x-icon"></use>
                    </svg>
                    <span>Die Konkurrenz ist zu stark und ist Online besser aufgestellt.</span>
                </div>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 text-red-500 shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#x-icon"></use>
                    </svg>
                    <span
                        >Deine potenziellen Mitarbeiter gehen zur Konkurrenz - und du bleibst auf
                        den offenen Stellen sitzen</span
                    >
                </div>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 text-red-500 shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#x-icon"></use>
                    </svg>
                    <span
                        >Verkaufszyklen dauern ewig, weil Kunden sich bei deinem Angebot einfach
                        nicht sicher sind?</span
                    >
                </div>
            </div>

            <div class="card colored flex flex-col gap-6">
                <h3 class="text-white font-medium">Unsere Lösung</h3>

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="hidden"
                    width="32"
                    height="32"
                    fill="currentColor"
                    viewBox="0 0 256 256">
                    <defs>
                        <path
                            id="check-icon"
                            d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
                    </defs>
                </svg>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 md:w-7 md:h-7 text-white shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#check-icon"></use>
                    </svg>
                    <span class="md:text-xl"
                        >Mit einer verkaufsstarken Website verwandelst du Website Besucher auch
                        wirklich in zahlende Kunden.</span
                    >
                </div>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 md:w-7 md:h-7 text-white shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#check-icon"></use>
                    </svg>
                    <span class="md:text-xl"
                        >Mit einer einzigartigen Website stellst in Zukunft DU deine Konkurrenz in
                        den Schatten</span
                    >
                </div>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 md:w-7 md:h-7 text-white shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#check-icon"></use>
                    </svg>
                    <span class="md:text-xl"
                        >Mit einer optimierten Website sind künftige Mitarbeiter schneller
                        überzeugt.</span
                    >
                </div>

                <div class="flex items-center gap-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 md:w-7 md:h-7 text-white shrink-0"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 256 256">
                        <use href="#check-icon"></use>
                    </svg>
                    <span class="md:text-xl"
                        >Eine optimierte Website filtert schon zu Beginn die Besucher aus und
                        liefert dir nur noch Premiumkunden</span
                    >
                </div>
            </div>
        </div>
    </div>
</div>
